import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const BASE_IMAGE_URL = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/";
//const DUMMY_IMAGE = `${BASE_IMAGE_URL}/dummy-vm-image.png`;

export default function RecentMachines({ recentVmlist = [] }) {
  const navigate = useNavigate();

  return (
    <Box pt={2}>
      <Typography
      style={{fontSize:"16px"}}
        variant="h6"
        sx={{ mb: 1, color: "rgba(113, 129, 152, 1)", fontWeight: 500 }}
      >
        Recent Machines
      </Typography>

      {/* Loading / Empty State */}
      {recentVmlist.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 100,
          }}
        >
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            gap: 2,
            pb: 1,
            scrollBehavior: "smooth",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {recentVmlist.map((machine, index) => (
            <Card
              key={index}
              sx={{
                minWidth: 110,
                maxWidth: 120,
                borderRadius: 2,
                boxShadow: 1,
                flexShrink: 0,
                cursor: "pointer",
                transition: "all 0.3s ease",
                "&:hover": { boxShadow: 3, transform: "scale(1.05)" },
              }}
              onClick={() => navigate(`/items?machineId=${machine?.id}&showItems=true`)}
            >
              <CardContent sx={{ p: 1.2, textAlign: "center" }}>
                <div style={{display:"flex",justifyContent: "center"}}>
                <img
                  src={
                    machine?.machineImagePath
                      ? `${BASE_IMAGE_URL}${machine?.machineImagePath}`
                      : "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/LocationTypeIcons/apartment_complex.png"
                  }
                  alt={machine?.vmName}
                  style={{
                    width: 70,
                    height: 70,
                    borderRadius: "10px",
                    objectFit: "contain",
                    marginBottom: "6px",
                  }}
                  onError={(e) => {
                    e.target.src =  "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/LocationTypeIcons/apartment_complex.png";
                  }}
                />
                </div>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: "#2c3e50",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontSize: 13,
                  }}
                >
                  {machine?.name || "Unnamed"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    fontSize: 11,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {machine?.address || "Unknown"}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      )}
    </Box>
  );
}
